import { render, staticRenderFns } from "./AutomaticOrder.vue?vue&type=template&id=71913e14&scoped=true&"
import script from "./AutomaticOrder.vue?vue&type=script&lang=js&"
export * from "./AutomaticOrder.vue?vue&type=script&lang=js&"
import style0 from "./AutomaticOrder.vue?vue&type=style&index=0&id=71913e14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71913e14",
  null
  
)

export default component.exports
import {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QDialog,QCard,QCardSection,QSeparator,QInput,QTable} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QBreadcrumbs,QBreadcrumbsEl,QBtn,QDialog,QCard,QCardSection,QSeparator,QInput,QTable})
